import React, { forwardRef } from 'react'
import { ReactComponent as Go } from './Go.svg'
import { ReactComponent as RectGoBack } from './RectGoBack.svg'

export const GoIcon = forwardRef<SVGSVGElement & { className: any }, React.PropsWithChildren<{ className?: string }>>(
  ({ className, ...props }, ref) => {
    const _className = 'transition text-gray-950 ' + (className || '')
    return <Go ref={ref} {...props} className={_className} />
  }
)

export const RectGoBackIcon = forwardRef<
  SVGSVGElement & { className: any },
  React.PropsWithChildren<{ className?: string }>
>(({ className, ...props }, ref) => {
  return <RectGoBack ref={ref} {...props} className={className || ''} />
})
